<template>
<div>
  <div v-if="dSites && dSites.length === 0" class="alert alert-info">
    <span v-if="!hasCurrentUserClaims('a')" v-html="$t('sites.err.emptySet', {
      adminEmail: env.VUE_APP_ADMIN_EMAIL,
      emailLink: generateEmailLink('assignMeSites', env.VUE_APP_ADMIN_EMAIL, {host: location.host, me: currentUser ? currentUser.email : ''}) })">
    </span>
    <span v-if="hasCurrentUserClaims('a')">
      {{$t('sites.err.emptySetAdmin')}}
      <router-link 
        :to="{name: 'UserEdit', params: {uid: 'me'}}"
        class="btn btn-primary">
        {{$t('users.editMe')}}
      </router-link>
    </span>
  </div>
  <router-link v-for="site in dSites" 
    :to="{name: 'Devices', params: {site: site.id}}" 
    v-bind:key="site.id" 
    class="btn btn-primary btn-block">
    <strong>{{site.name}}</strong>
  </router-link>
</div>
</template>

<script>

import db from '@/firebase/init'
import firebase from 'firebase'
import SkVars from '../mixins/SkVars'
import SitesVars from '../mixins/SitesVars'

export default {
  name: 'Sites',
  mixins: [SkVars, SitesVars],
  created() { this.dataInitSites(true) }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/Sites.vue